import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import html2pdf from "html2pdf.js";

import { parseDataByObjectKey } from '../../../utils/common';
import statusAction from "../../../redux/status/actions";
import featureAction from "../../../redux/feature/actions";

import "./OnCanvas.css";

import Title from "../../../components/Title/Title"
import TotalPrice from "./TotalPrice";
import ClaysOnCanvas from "./ClaysOnCanvas";

import { useTranslation } from "react-i18next";
import {changeLanguage} from "i18next";

function OnCanvas() {
  // assets init
  const assetsPath = useSelector(state => state.Feature.assetsPath);
  const downloadPdf = process.env.PUBLIC_URL + assetsPath + 'images/download-pdf.svg';

  /*api integration start*/
  const dispatch = useDispatch();
  const generatePDF = () => {
    dispatch(statusAction.dowloadPdf());
    setTimeout(() => {
      dispatch(statusAction.dowloadPdf()); // Second call after 1 second
    }, 1000); // Delay in milliseconds (1000ms = 1s)
  }

  const coloursOnCanvas = parseDataByObjectKey(useSelector(state => state.Feature.coloursOnCanvas), 'product_name');
  const _priceData = parseDataByObjectKey(useSelector(state => state.Feature.priceData), 'product_name');
  /*api integration end*/

  const userData = useSelector(state => state.Feature);
  const addToCart = () => {
    const priceData = [...userData.priceData].map(item => {
      return {
        id_product_attribute: item.id_product_attribute,
        qty: item.m2,
      }
    });
    dispatch({type: featureAction.ADD_TO_CART_REQUEST, payload: {priceData, customerId: userData.customerId || 0}});
  }

  const { t, i18n } = useTranslation();

/*  const testLanguage = () => {
    i18n.changeLanguage('en');
  }*/

  const lng = useSelector(state => state.Feature.language);

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng]);

  return (
    <div className="acp-acp-oncanvas-grid-container m-top">

      <Title title={t('ON CANVAS')}/>

      <div className='acp-oncanvas-grid'>

        <div className='acp-header acp-d-flex'>
          <div>{t('Colour')}</div>
          <div>M<sup>2</sup></div>
          <div>{t('Total')}</div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </div>

        <div className='acp-oncanvas-grid-body'>
          {
            Object.entries(_priceData).map(([key, data], index) => (
              <ClaysOnCanvas key={index} category={key} data={data}/>
            ))
          }
        </div>
      </div>
      <div className='price-info'>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-help-circle">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 16v.01" />
            <path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
          </svg>
          <span>{t('All prices calculated based on 25kg plaster bags')}</span>
        </div>
      </div>
      <div className='acp-checkout acp-jc-space-between'>
        <TotalPrice/>
        <div className='acp-d-flex'>
          <div className='acp-download-pdf' onClick={generatePDF}>
            <img src={downloadPdf} alt='color'/>
          </div>
          <div className='acp-add-to-cart' onClick={addToCart}>{t('Add to cart')}</div>
        </div>
      </div>
    </div>
  );
}

export default OnCanvas;